module.exports = __webpack_public_path__ + "static/media/Bupa Hong Kong  Color.9f8ebc98.png";